import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { GoPrimitiveDot } from "react-icons/go";
import { Card, Chip, ChipTxt, CardContainer, Container, Title } from "./style";
import "./style.css";
import * as storage from "../../utils/storage";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

type Anchor = "top" | "left" | "bottom" | "right";

interface props {
  bottom: any;
  onChange: any;
  imagePicker: any;
  filePicker?: boolean
}

export default function SwipeableTemporaryDrawer({ bottom, onChange, imagePicker, filePicker=false }: props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: bottom,
    right: false,
  });

  useEffect(() => {
    setState({ ...state, bottom: bottom });
  }, [bottom]);

  const toggleDrawer = (anchor: Anchor, open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    if (
      event &&
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }
    onChange({ bottom: false });
    setState({ ...state, [anchor]: open });
  };

  const setConfirm = async (val: any) => {
    console.log({val});
    let saveToGallery = false;
    let settings: any = await storage.get(storage.KEYS.HOME_PAGE_SETTINGS);
    console.log({settings});
    if(settings) {
      settings = JSON.parse(settings);
      saveToGallery = settings.save_photos_to_gallery;
    }
    imagePicker(true, val, saveToGallery);
  };

  const list = (anchor: Anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Container>
        <CardContainer>
          <Card onClick={() => setConfirm("Camera")}>
            <Chip>
              <GoPrimitiveDot />
              <Title>Camera</Title>
            </Chip>
            <ChipTxt>Capture a photo to upload</ChipTxt>
          </Card>
          <Card  onClick={() => setConfirm("Gallery")}>
            <Chip>
              <GoPrimitiveDot />
              <Title>Gallery</Title>
            </Chip>
            <ChipTxt>Select images from gallery to upload</ChipTxt>
          </Card>
          { filePicker && <Card  onClick={() => setConfirm("File")}>
            <Chip>
              <GoPrimitiveDot />
              <Title>File</Title>
            </Chip>
            <ChipTxt>Select files to upload</ChipTxt>
          </Card> }
        </CardContainer>
      </Container>
    </div>
  );

  return (
    <div>
      {(["left", "right", "top", "bottom"] as Anchor[]).map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            disableBackdropTransition
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
